<app-table
           [table]="billsTable"
           [tableColumns]="billsTableColumns"
           [tableData]="billPayment?.bills"
           [totalRows]="billPayment?.bills?.length">
</app-table>
<h3 class="text-center">Total: </h3>
<p class="text-center">{{billPayment.totalAmount | currency:billPayment.currency:'symbol-narrow'}} </p>
